import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'

export function AttachmentCell({ row }) {
  const { t } = useTranslation('AttachmentCell')
  const feedback = row.original
  const isResumeReview = feedback.type === 'ServiceRequest::ResumeReview'
  const attachments = isResumeReview
    ? feedback.resume_review_documents
    : feedback.coach_documents

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        {attachments.length > 0 ? (
          <div className="flex flex-col gap-2">
            {attachments.map((attachment, idx) => (
              <div key={`coach-attachment-${idx}`} className="flex flex-col">
                <a target="_blank" rel="noreferrer" href={attachment.url}>
                  {attachment.name || attachment.fileName}
                </a>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col">{t('no_attachment')}</div>
        )}
      </div>
    </div>
  )
}

export const AttachmentLink = ({ className, feedback, children }) => {
  const uploadedDocument = feedback.uploaded_document

  const downloadUrlExists = !!uploadedDocument?.url
  const documentName = feedback.uploaded_document_name

  return (
    <div className={className}>
      {downloadUrlExists && (
        <a
          target="_blank"
          rel="noreferrer"
          href={feedback.uploaded_document.url}
        >
          {documentName}
        </a>
      )}
      {!downloadUrlExists && children}
    </div>
  )
}
